import { IEntregaObrasService } from "../services/entrega_obras_service";
import { Paginated } from "../../../../common/domain/models/paginated_models";
import { ChecklistEntrega } from "../../domain/models/checklist_entrega";
import { ItemChecklistEntrega } from "../../domain/models/item_checklist_entrega";
import { SatiscacaoClienteLista } from "../../domain/models/satisfacao_cliente_lista";
import { PesquisaSatiscacaoClienteLista } from "../../domain/models/pesquisa_satisfacao_cliente_lista";
import { SatisfacaoClienteDetalhe } from "../../domain/models/satisfacao_cliente_detalhe";
import { ItemPesquisaClienteLista } from "../../domain/models/item_pesquisa_cliente_lista";
import { PesquisaSatisfacaoDropDown } from "../../domain/models/pesquisa_satisfacao_dropdown";
import { Termo } from "../../domain/models/termo";
import { EntregaObraModel } from "../../domain/models/entrega_obra_model";
import { EntregaObrasListaModel } from "../../domain/models/entrega_obras_lista";
import { PesquisaSatisfacaoLista } from "../../domain/models/pesquisa_satisfacao_lista";
import { EntregaObraParametros } from "../../domain/models/entrega_obra_parametros";
import { EntregaObraClienteLista } from '../../domain/models/entrega_obra_cliente_lista';
import { EntregaObraClienteArquivoModel } from '../../domain/models/entrega_obra_cliente_arquivo';
import { EntregaObraClienteTermoModel } from '../../domain/models/entrega_obra_cliente_termo';
import { EntregaObraClienteArquivoAuxModel } from '../../domain/models/entrega_obra_cliente_arquivo_aux';
import { InformacoesEntregaObraClienteModel } from '../../domain/models/informacoes_entrega_obra_cliente';
import { VerificacaoChecklistModel } from '../../domain/models/verificacao_checklist';
import { EntregaObraClienteChecklist } from '../../domain/models/entrega_obra_cliente_checklist';
import { IEntregaObrasRepository } from '../../domain/repositories/entrega_obras_repositories';
import { PesquisaSatisfacaoItemLista } from "../../domain/models/pesquisa_satisfacao_item_lista";
import { PesquisaSatisfacaoDetalhes } from "../../domain/models/pesquisa_satisfacao_detalhes";
import { CategoriaAssistenciaLista } from "../../domain/models/categoria_assistencia_lista";
import { AssistenciaTecnicaLista } from "../../domain/models/assistencia_tecnica_lista";
import { CategoriaAssistenciaDropDown } from "../../domain/models/categoria_assistencia_dropdown";
import { AssistenciaTecnicaDetalhe } from "../../domain/models/assistencia_tecnica_detalhe";
import { AssistenciaTecnicaAtendimentoLista } from "../../domain/models/assistencia_tecnica_atendimento_lista";
import { AssistenciaTecnicaPesquisaLista } from "../../domain/models/assistencia_tecnica_pesquisa_lista";
import { AssistenciaTecnicaArquivoLista } from "../../domain/models/assistencia_tecnica_arquivo_lista";
import { AssistenciaTecnicaCategoriaLista } from "../../domain/models/assistencia_tecnica_categoria_lista";
import { ItemPesquisaEntregaObra } from '../../domain/models/item_pesquisa_entrega_obra';
import { EntregaObraPesquisaSatisfacao } from '../../domain/models/entrega_obra_pesquisa_satisfacao';
import { EntregaObraPesquisaSatisfacaoLista } from '../../domain/models/entrega_obra_pesquisa_satisfacao_lista';
import { EntregaObraGrafico } from '../../domain/models/entrega_obra_cliente_grafico';
import { DashboardEntregaObras } from '../../domain/models/dashboard_entrega_obras';
import { ChecklistEntregaAmbienteModel } from "../../domain/models/checklist_entrega_ambiente";



export class EntregaObrasRepository implements IEntregaObrasRepository {
    constructor(
        private readonly service: IEntregaObrasService,
    ) { }

    //#region ChecklistEntrega 

    async getChecklistEntregaById(idChecklistEntrega: number): Promise<ChecklistEntrega> {
        const result = await this.service.getChecklistEntregaById({ idChecklistEntrega });
        return { ...result };
    }

    async getAllChecklistEntregas(
        codigo?: string,
        descricao?: string,
        status?: number,
        currentPage?: number,
        rowsPerPage?: number
    ): Promise<Paginated<ChecklistEntrega>> {
        const result = await this.service.getAllChecklistEntregas({ codigo, descricao, status, currentPage, rowsPerPage });
        return { ...result };
    }

    async deleteChecklistEntregaById(idChecklistEntrega: number): Promise<void> {
        await this.service.deleteChecklistEntregaById(idChecklistEntrega);
    }

    async createChecklistEntrega(
        codigo?: string,
        descricao?: string,
        revisao?: string,
        campo1?: string,
        campo2?: string,
        campo3?: string,
        campo4?: string,
    ): Promise<number> {
        const result = await this.service.createChecklistEntrega({
            codigo: codigo,
            descricao: descricao,
            revisao: revisao,
            campo1: campo1,
            campo2: campo2,
            campo3: campo3,
            campo4: campo4,
        });
        return result.idChecklistEntrega;
    }

    async updateChecklistEntrega(
        idChecklistEntrega: number,
        codigo?: string,
        descricao?: string,
        revisao?: string,
        campo1?: string,
        campo2?: string,
        campo3?: string,
        campo4?: string,
        ativo?: boolean,
    ): Promise<void> {
        await this.service.updateChecklistEntrega({
            idChecklistEntrega: idChecklistEntrega,
            codigo: codigo,
            descricao: descricao,
            revisao: revisao,
            campo1: campo1,
            campo2: campo2,
            campo3: campo3,
            campo4: campo4,
            ativo: ativo,
        });
    }

    async copiaChecklistEntrega(
        idChecklistEntrega: number,
        codigo?: string,
        descricao?: string,
        revisao?: string,
    ): Promise<void> {
        await this.service.copiaChecklistEntrega({
            idChecklistEntrega: idChecklistEntrega,
            codigo: codigo,
            descricao: descricao,
            revisao: revisao,
        });
    }

    //#endregion

    //#region ChecklistEntregaAmbiente

    async getChecklistEntregaAmbienteById(idChecklistEntregaAmbiente: number): Promise<ChecklistEntregaAmbienteModel> {
        const result = await this.service.getChecklistEntregaAmbienteById({ idChecklistEntregaAmbiente });
        return { ...result };
    }

    async getAllChecklistEntregaAmbientes(
        idChecklistEntrega: number,
        descricao?: string,

        currentPage?: number,
        rowsPerPage?: number
    ): Promise<Paginated<ChecklistEntregaAmbienteModel>> {
        const result = await this.service.getAllChecklistEntregaAmbientes({ idChecklistEntrega, descricao, page: currentPage, rowsPerPage });
        return { ...result };
    }

    async deleteChecklistEntregaAmbienteById(idChecklistEntregaAmbiente: number): Promise<void> {
        await this.service.deleteChecklistEntregaAmbienteById(idChecklistEntregaAmbiente);
    }

    async createChecklistEntregaAmbiente(
        idChecklistEntrega: number,
        descricao?: string,
        ordem?: string,
    ): Promise<number> {
        const result = await this.service.createChecklistEntregaAmbiente({
            idChecklistEntrega: idChecklistEntrega,
            descricao: descricao,
            ordem: ordem,
        });

        return result.idChecklistEntregaAmbiente;
    }

    async updateChecklistEntregaAmbiente(
        idChecklistEntregaAmbiente: number,
        descricao?: string,
        ordem?: string,
    ): Promise<void> {
        await this.service.updateChecklistEntregaAmbiente({
            idChecklistEntregaAmbiente: idChecklistEntregaAmbiente,
            descricao: descricao,
            ordem: ordem,
        });
    }

    async copiaChecklistEntregaAmbiente(
        idChecklistEntregaAmbiente: number,
        ordem?: string,
        descricao?: string,
    ): Promise<void> {
        await this.service.copiaChecklistEntregaAmbiente({
            idChecklistEntregaAmbiente: idChecklistEntregaAmbiente,
            ordem: ordem,
            descricao: descricao,
        });
    }

    //#endregion

    //#region ItemChecklistEntrega 

    async getItemChecklistEntregaById(idItemChecklistEntrega: number): Promise<ItemChecklistEntrega> {
        const result = await this.service.getItemChecklistEntregaById({ idItemChecklistEntrega });
        return { ...result };
    }

    async getAllItemChecklistEntregas(
        idChecklistEntregaAmbiente: number,
        ordem?: string,
        descricao?: string,
        currentPage?: number,
        rowsPerPage?: number
    ): Promise<Paginated<ItemChecklistEntrega>> {
        const result = await this.service.getAllItemChecklistEntregas({
            idChecklistEntregaAmbiente,
            ordem,
            descricao,
            currentPage,
            rowsPerPage
        });
        return { ...result };
    }

    async deleteItemChecklistEntregaById(idItemChecklistEntrega: number): Promise<void> {
        await this.service.deleteItemChecklistEntregaById(idItemChecklistEntrega);
    }

    async createItemChecklistEntrega(
        idChecklistEntregaAmbiente: number,
        descricao?: string,
        ordem?: string,
    ): Promise<number> {
        const result = await this.service.createItemChecklistEntrega({
            idChecklistEntregaAmbiente: idChecklistEntregaAmbiente,
            descricao: descricao,
            ordem: ordem,
        });
        return result.idItemChecklistEntrega;
    }

    async updateItemChecklistEntrega(
        idItemChecklistEntrega: number,
        descricao?: string,
        ordem?: string,
    ): Promise<void> {
        await this.service.updateItemChecklistEntrega({
            idItemChecklistEntrega: idItemChecklistEntrega,
            descricao: descricao,
            ordem: ordem,
        });
    }

    //#endregion

    // INICIO VITOR

    async getPesquisaSatisfacaoDropDown(
    ): Promise<PesquisaSatisfacaoDropDown[]> {
        const response = await this.service.getPesquisaSatisfacaoDropDown({});
        return response.itens;
    }

    async getAssistenciaCategoriaDropDown(
    ): Promise<CategoriaAssistenciaDropDown[]> {
        const response = await this.service.getAssistenciaCategoriaDropDown({});
        return response.itens;
    }

    async getAllSatisfacaoCliente(
        centroCustos: number[] | null,
        status: number | null,
        clientes: number[] | null,
        pesquisaCliente: string | null,
        page: number,
        rowsPerPage: number,
    ): Promise<Paginated<SatiscacaoClienteLista>> {
        return await this.service.getAllSatisfacaoCliente({
            centroCustos,
            status,
            clientes,
            pesquisaCliente,
            page,
            rowsPerPage,
        });
    }

    async createSatisfacaoCliente(
        status: number,
        centroCusto: number,
        cliente: number | null,
        nomeCliente: string | null,
        data: Date | null,
    ): Promise<void> {
        await this.service.createSatisfacaoCliente({
            status,
            centroCusto,
            cliente,
            nomeCliente,
            data,
        });
    }

    async updateSatisfacaoCliente(
        idSatisfacaoCliente: number,
        status: number,
        centroCusto: number,
        cliente: number | null,
        nomeCliente: string | null,
        data: Date | null,
    ): Promise<void> {
        await this.service.updateSatisfacaoCliente({
            idSatisfacaoCliente,
            status,
            centroCusto,
            cliente,
            nomeCliente,
            data,
        });
    }

    async deleteSatisfacaoCliente(
        idSatisfacaoCliente: number,
    ): Promise<void> {
        await this.service.deleteSatisfacaoCliente({
            idSatisfacaoCliente,
        });
    }

    async getAllPesquisaSatisfacaoCliente(
        idSatisfacaoCliente: number,
        respondidaPor: string | null,
        data: Date | null,
        local: string | null,
        status: number,
        page: number,
        rowsPerPage: number,
    ): Promise<Paginated<PesquisaSatiscacaoClienteLista>> {
        return await this.service.getAllPesquisaSatisfacaoCliente({
            idSatisfacaoCliente,
            respondidaPor,
            data,
            local,
            status,
            page,
            rowsPerPage,
        });
    }

    async getByIdSatisfacaoCliente(
        idSatisfacaoCliente: number,
    ): Promise<SatisfacaoClienteDetalhe | null> {
        const result = await this.service.getByIdSatisfacaoCliente({ idSatisfacaoCliente });
        return result.item;
    }

    async getAllItemPesquisaCliente(
        idPesquisaSatisfacaoCliente: number,
    ): Promise<ItemPesquisaClienteLista[]> {
        const response = await this.service.getAllItemPesquisaCliente({
            idPesquisaSatisfacaoCliente,
        });
        return response.itens;
    }

    async createPesquisaSatisfacaoCliente(
        idSatisfacaoCliente: number,
        idsPesquisaSatisfacao: number[],
    ): Promise<void> {
        await this.service.createPesquisaSatisfacaoCliente({
            idSatisfacaoCliente,
            idsPesquisaSatisfacao,
        });
    }

    async updatePesquisaSatisfacaoCliente(
        idPesquisaSatisfacaoCliente: number,
        respondidaPor: string | null,
        data: Date | null,
        local: string | null,
        status: number,
        observacao: string | null,
        itens: {
            idItemPesquisaCliente: number;
            nota: number | null;
        }[],
    ): Promise<void> {
        await this.service.updatePesquisaSatisfacaoCliente({
            idPesquisaSatisfacaoCliente,
            respondidaPor,
            data,
            local,
            status,
            observacao,
            itens,
        });
    }

    async deletePesquisaSatisfacaoCliente(
        idPesquisaSatisfacaoCliente: number
    ): Promise<void> {
        await this.service.deletePesquisaSatisfacaoCliente({
            idPesquisaSatisfacaoCliente,
        });
    }

    async getAllPesquisaSatisfacao(
        field: number | null,
        value: string | null,
        status: number | null,
        page: number,
        rowsPerPage: number,
    ): Promise<Paginated<PesquisaSatisfacaoLista>> {
        return await this.service.getAllPesquisaSatisfacao({
            field,
            value,
            status,
            page,
            rowsPerPage,
        });
    }

    async getPesquisaSatisfacaoById(
        idPesquisaSatisfacao: number
    ): Promise<PesquisaSatisfacaoDetalhes | null> {
        const response = await this.service.getPesquisaSatisfacaoById({
            idPesquisaSatisfacao,
        });
        return response.item;
    }

    async createPesquisaSatisfacao(
        status: number,
        codigo: string,
        descricao: string,
    ): Promise<void> {
        await this.service.createPesquisaSatisfacao({
            status,
            codigo,
            descricao,
        });
    }

    async updatePesquisaSatisfacao(
        idPesquisaSatisfacao: number,
        status: number,
        codigo: string,
        descricao: string,
    ): Promise<void> {
        await this.service.updatePesquisaSatisfacao({
            idPesquisaSatisfacao,
            status,
            codigo,
            descricao,
        });
    }

    async deletePesquisaSatisfacao(
        idPesquisaSatisfacao: number,
    ): Promise<void> {
        await this.service.deletePesquisaSatisfacao({
            idPesquisaSatisfacao,
        });
    }

    async getAllPesquisaSatisfacaoItem(
        idPesquisaSatisfacao: number,
        page: number,
        rowsPerPage: number
    ): Promise<Paginated<PesquisaSatisfacaoItemLista>> {
        return await this.service.getAllPesquisaSatisfacaoItem({
            idPesquisaSatisfacao,
            page,
            rowsPerPage,
        });
    }

    async createPesquisaSatisfacaoItem(
        idPesquisaSatisfacao: number,
        ordem: string,
        descricao: string,
    ): Promise<void> {
        await this.service.createPesquisaSatisfacaoItem({
            idPesquisaSatisfacao,
            ordem,
            descricao,
        });
    }

    async updatePesquisaSatisfacaoItem(
        idItemPesquisaSatisfacao: number,
        ordem: string,
        descricao: string,
    ): Promise<void> {
        await this.service.updatePesquisaSatisfacaoItem({
            idItemPesquisaSatisfacao,
            ordem,
            descricao,
        });
    }

    async deletePesquisaSatisfacaoItem(
        idItemPesquisaSatisfacao: number,
    ): Promise<void> {
        await this.service.deletePesquisaSatisfacaoItem({
            idItemPesquisaSatisfacao,
        });
    }

    async getAllCategoriaAssistencia(
        field: number | null,
        value: string | null,
        status: number | null,
        page: number,
        rowsPerPage: number,
    ): Promise<Paginated<CategoriaAssistenciaLista>> {
        return await this.service.getAllCategoriaAssistencia({
            field,
            value,
            status,
            page,
            rowsPerPage,
        });
    }

    async createCategoriaAssistencia(
        status: number,
        categoria: string
    ): Promise<void> {
        await this.service.createCategoriaAssistencia({
            status,
            categoria,
        });
    }

    async updateCategoriaAssistencia(
        idCategoriaAssistencia: number,
        status: number,
        categoria: string
    ): Promise<void> {
        await this.service.updateCategoriaAssistencia({
            idCategoriaAssistencia,
            status,
            categoria,
        });
    }

    async deleteCategoriaAssistencia(
        idCategoriaAssistencia: number,
    ): Promise<void> {
        await this.service.deleteCategoriaAssistencia({
            idCategoriaAssistencia,
        });
    }

    async getAllAssistenciaTecnica(
        idCliente: number[] | null,
        cliente: string | null,
        centroCustos: number[] | null,
        local: string | null,
        dataAberturaDe: Date | null,
        dataAberturaAte: Date | null,
        tipo: number | null,
        dataEncerramentoDe: Date | null,
        dataEncerramentoAte: Date | null,
        codigo: number | null,
        procedente: number | null,
        categorias: number[] | null,
        resolvido: number | null,
        prioridade: number | null,
        nroChamado: string | null,
        status: number | null,
        page: number,
        rowsPerPage: number,
    ): Promise<Paginated<AssistenciaTecnicaLista>> {
        return await this.service.getAllAssistenciaTecnica({
            idCliente,
            cliente,
            centroCustos,
            local,
            dataAberturaDe,
            dataAberturaAte,
            tipo,
            dataEncerramentoDe,
            dataEncerramentoAte,
            codigo,
            procedente,
            categorias,
            resolvido,
            prioridade,
            nroChamado,
            status,
            page,
            rowsPerPage,
        });
    }

    async deleteAssistenciaTecnica(
        idAssistenciaTecnica: number,
    ): Promise<void> {
        await this.service.deleteAssistenciaTecnica({
            idAssistenciaTecnica,
        });
    }

    async getAssistenciaTecnicaById(
        idAssistenciaTecnica: number
    ): Promise<AssistenciaTecnicaDetalhe | null> {
        const result = await this.service.getAssistenciaTecnicaById({
            idAssistenciaTecnica,
        });
        return result.item;
    }



    async createAssistenciaTecnica(
        codigo: string | null,
        tipo: number | null,
        centroCusto: number | null,
        cliente: string | null,
        idClienteCentroCusto: number | null,
        unidade: string | null,
        dataAbertura: Date | null,
        contato: string | null,
        previsaoRealizacaoVistoria: Date | null,
        prioridade: number | null,
        previsaoTerminoAssistencia: Date | null,
        reclamacao: string | null,
        procedente: number | null,
        dataReparo: Date | null,
        taxa: boolean | null,
        taxaCliente: boolean | null,
        valorTaxa: number | null,
        resolvido: number | null,
        dataEncerramento: Date | null,
        observacoes: string | null,
        custo: number | null,
        nroChamado: string | null,
        acoesCorretivas: string | null,
        clienteCadastrado: boolean | null,
        statusAssistencia: number | null,
        categorias: {
            idCategoriaAssistencia: number | null;
            nomeCategoria: string | null;
            ativo: boolean | null;
        }[] | null,
    ): Promise<number> {
        const result = await this.service.createAssistenciaTecnica({
            codigo,
            tipo,
            centroCusto,
            cliente,
            idClienteCentroCusto,
            unidade,
            dataAbertura,
            contato,
            previsaoRealizacaoVistoria,
            prioridade,
            previsaoTerminoAssistencia,
            reclamacao,
            procedente,
            dataReparo,
            taxa,
            taxaCliente,
            valorTaxa,
            resolvido,
            dataEncerramento,
            observacoes,
            custo,
            nroChamado,
            acoesCorretivas,
            clienteCadastrado,
            statusAssistencia,
            categorias,
        });

        return result.idAssistenciaTecnica;
    }

    async updateAssistenciaTecnica(
        idAssistenciaTecnica: number,
        codigo: string | null,
        tipo: number | null,
        centroCusto: number | null,
        cliente: string | null,
        idClienteCentroCusto: number | null,
        unidade: string | null,
        dataAbertura: Date | null,
        contato: string | null,
        previsaoRealizacaoVistoria: Date | null,
        prioridade: number | null,
        previsaoTerminoAssistencia: Date | null,
        reclamacao: string | null,
        procedente: number | null,
        dataReparo: Date | null,
        taxa: boolean | null,
        taxaCliente: boolean | null,
        valorTaxa: number | null,
        resolvido: number | null,
        dataEncerramento: Date | null,
        observacoes: string | null,
        custo: number | null,
        nroChamado: string | null,
        acoesCorretivas: string | null,
        clienteCadastrado: boolean | null,
        statusAssistencia: number | null,
        categorias: {
            idCategoriaAssistencia: number | null;
            nomeCategoria: string | null;
            ativo: boolean | null;
        }[] | null,
    ): Promise<void> {
        await this.service.updateAssistenciaTecnica({
            idAssistenciaTecnica,
            codigo,
            tipo,
            centroCusto,
            cliente,
            idClienteCentroCusto,
            unidade,
            dataAbertura,
            contato,
            previsaoRealizacaoVistoria,
            prioridade,
            previsaoTerminoAssistencia,
            reclamacao,
            procedente,
            dataReparo,
            taxa,
            taxaCliente,
            valorTaxa,
            resolvido,
            dataEncerramento,
            observacoes,
            custo,
            nroChamado,
            acoesCorretivas,
            clienteCadastrado,
            statusAssistencia,
            categorias,
        });
    }

    async getAllAssistenciaRegistroAtendimento(
        idAssistenciaTecnica: number,
        page: number,
        rowsPerPage: number
    ): Promise<Paginated<AssistenciaTecnicaAtendimentoLista>> {
        return await this.service.getAllAssistenciaRegistroAtendimento({
            idAssistenciaTecnica,
            page,
            rowsPerPage,
        });
    }

    async getAllAssistenciaPesquisaSatisfacao(
        idAssistenciaTecnica: number,
        page: number,
        rowsPerPage: number,
    ): Promise<Paginated<AssistenciaTecnicaPesquisaLista>> {
        return await this.service.getAllAssistenciaPesquisaSatisfacao({
            idAssistenciaTecnica,
            page,
            rowsPerPage,
        });
    }

    async getAllAssistenciaArquivoDiverso(
        idAssistenciaTecnica: number,
        page: number,
        rowsPerPage: number,
    ): Promise<Paginated<AssistenciaTecnicaArquivoLista>> {
        return await this.service.getAllAssistenciaArquivoDiverso({
            idAssistenciaTecnica,
            page,
            rowsPerPage,
        });
    }

    async getAllAssistenciaCategoria(
        idAssistenciaTecnica: number,
    ): Promise<AssistenciaTecnicaCategoriaLista[]> {
        const response = await this.service.getAllAssistenciaCategoria({
            idAssistenciaTecnica,
        });
        return response.itens;
    }

    async createAssistenciaRegistroAtendimento(
        idAssistenciaTecnica: number,
        tipo: number,
        descricao: string,
        dataInicio: Date | null,
        dataTermino: Date | null,
        observacoes: string | null,
        responsavelConstrutora: number | null,
        responsavelCliente: string | null,
    ): Promise<void> {
        await this.service.createAssistenciaRegistroAtendimento({
            idAssistenciaTecnica,
            tipo,
            descricao,
            dataInicio,
            dataTermino,
            observacoes,
            responsavelConstrutora,
            responsavelCliente,
        });
    }

    async updateAssistenciaRegistroAtendimento(
        idAssistenciaTecnica: number,
        idAssistenciaAtendimento: number,
        tipo: number,
        descricao: string,
        dataInicio: Date | null,
        dataTermino: Date | null,
        observacoes: string | null,
        responsavelConstrutora: number | null,
        responsavelCliente: string | null,
    ): Promise<void> {
        await this.service.updateAssistenciaRegistroAtendimento({
            idAssistenciaTecnica,
            idAssistenciaAtendimento,
            tipo,
            descricao,
            dataInicio,
            dataTermino,
            observacoes,
            responsavelConstrutora,
            responsavelCliente,
        });
    }

    async deleteAssistenciaRegistroAtendimento(
        idAssistenciaTecnica: number,
        idAssistenciaAtendimento: number,
    ): Promise<void> {
        await this.service.deleteAssistenciaRegistroAtendimento({
            idAssistenciaTecnica,
            idAssistenciaAtendimento,
        });
    }

    async createAssistenciaPesquisaSatisfacao(
        idAssistenciaTecnica: number,
        idPesquisaSatisfacao: number,
    ): Promise<void> {
        await this.service.createAssistenciaPesquisaSatisfacao({
            idAssistenciaTecnica,
            idPesquisaSatisfacao,
        });
    }

    async deleteAssistenciaPesquisaSatisfacao(
        idAssistenciaTecnica: number,
        idPesquisaSatisfacaoCliente: number,
    ): Promise<void> {
        await this.service.deleteAssistenciaPesquisaSatisfacao({
            idAssistenciaTecnica,
            idPesquisaSatisfacaoCliente,
        });
    }

    async createAssistenciaArquivoDiverso(
        idAssistenciaTecnica: number,
        descricao: string,
        arquivo: File | null,
    ): Promise<void> {
        await this.service.createAssistenciaArquivoDiverso({
            idAssistenciaTecnica,
            descricao,
            arquivo,
        });
    }

    async updateAssistenciaArquivoDiverso(
        idAssistenciaTecnica: number,
        idAssistenciaArquivo: number,
        descricao: string,
        arquivo: File | null,
        limparArquivo: boolean,
    ): Promise<void> {
        await this.service.updateAssistenciaArquivoDiverso({
            idAssistenciaTecnica,
            idAssistenciaArquivo,
            descricao,
            arquivo,
            limparArquivo,
        });
    }

    async deleteAssistenciaArquivoDiverso(
        idAssistenciaTecnica: number,
        idAssistenciaArquivo: number,
    ): Promise<void> {
        await this.service.deleteAssistenciaArquivoDiverso({
            idAssistenciaTecnica,
            idAssistenciaArquivo,
        });
    }

    async downloadAssistenciaArquivoDiverso(
        idAssistenciaTecnica: number,
        idAssistenciaArquivo: number,
    ): Promise<Blob> {
        return await this.service.downloadAssistenciaArquivoDiverso({
            idAssistenciaTecnica,
            idAssistenciaArquivo,
        });
    }

    // FIM VITOR
    //#region Termo

    async getTermoById(idTermo: number): Promise<Termo> {
        const result = await this.service.getTermoById({ idTermo });
        return { ...result };
    }

    async getAllTermos(
        codigo?: string,
        descricao?: string,
        nome?: string,
        status?: number,

        currentPage?: number,
        rowsPerPage?: number
    ): Promise<Paginated<Termo>> {
        const result = await this.service.getAllTermos({ codigo, descricao, nome, status, currentPage, rowsPerPage });
        return { ...result };
    }

    async deleteTermoById(idTermo: number): Promise<void> {
        await this.service.deleteTermoById(idTermo);
    }

    async createTermo(
        codigo?: string,
        descricao?: string,
        nome?: string
    ): Promise<number> {
        const result = await this.service.createTermo({
            codigo: codigo,
            descricao: descricao,
            nome: nome,
            ativo: true,
        });
        return result.idTermo;
    }

    async updateTermo(
        idTermo: number,
        codigo?: string,
        descricao?: string,
        nome?: string,
        ativo?: boolean
    ): Promise<void> {
        await this.service.updateTermo({
            idTermo: idTermo,
            codigo: codigo,
            descricao: descricao,
            nome: nome,
            ativo: ativo,
        });
    }

    //#endregion
    //#region EntregaObra

    async getEntregaObraParametros(idEntregaObra: number): Promise<EntregaObraParametros> {
        const result = await this.service.getEntregaObraParametros({ idEntregaObra });
        return { ...result };
    }

    async getEntregaObraById(idEntregaObra: number): Promise<EntregaObraModel> {
        const result = await this.service.getEntregaObraById({ idEntregaObra });
        return { ...result };
    }

    async getAllEntregaObra(
        idsCentroCusto?: number[],
        status?: number,

        currentPage?: number,
        rowsPerPage?: number
    ): Promise<Paginated<EntregaObrasListaModel>> {

        const result = await this.service.getAllEntregaObra({ idsCentroCusto, status, currentPage, rowsPerPage });

        return { ...result };

    }

    async deleteEntregaObraById(idEntregaObra: number): Promise<void> {
        await this.service.deleteEntregaObraById(idEntregaObra);

    }

    async createEntregaObra(
        status: number,
        idCentroCusto: number,
    ): Promise<number> {
        const result = await this.service.createEntregaObra({
            status: status,
            idCentroCusto: idCentroCusto,
        });
        return result.idEntregaObra;
    }

    async updateEntregaObra(
        idEntregaObra: number,
        status: number,
        idCentroCusto: number,
    ): Promise<void> {
        await this.service.updateEntregaObra({
            idEntregaObra: idEntregaObra,
            status: status,
            idCentroCusto: idCentroCusto,
        });
    }

    async getEntregaObraGrafico(idEntregaObra: number): Promise<EntregaObraGrafico> {
        const result = await this.service.getEntregaObraGrafico({ idEntregaObra });
        return { ...result.item };
    }

    //#endregion

    //#region  EntregaObrasCliente

    async getAllEntregaObrasClienteLista(
        idEntregaObra: number,
        idsClientes?: number[],
        idsChecklist?: number[],
        tipoVistoria?: number,
        entregue?: number,
        unidade?: string,
        localVistoria?: string,
        dataDe?: Date,
        dataAte?: Date,
        currentPage?: number,
        rowsPerPage?: number
    ): Promise<Paginated<EntregaObraClienteLista>> {
        const result = await this.service.getAllEntregaObrasClienteLista({
            idEntregaObra,
            idsClientes,
            idsChecklist,
            tipoVistoria,
            entregue,
            unidade,
            localVistoria,
            dataDe,
            dataAte,
            currentPage,
            rowsPerPage,
        });
        return { ...result };
    }

    async getEntregaObrasClienteChecklistById(
        idEntregaObraCliente: number,
    ): Promise<EntregaObraClienteChecklist> {
        const result = await this.service.getEntregaObrasClienteChecklistById({ idEntregaObraCliente });
        return { ...result };
    }

    async deleteEntregaObraClienteById(idEntregaObraCliente: number): Promise<void> {
        await this.service.deleteEntregaObraClienteById(idEntregaObraCliente);
    }

    async createEntregaObrasCliente(
        idEntregaObra: number,
        idClienteUnidade: number,
        idCentroCusto: number,
        idsChecklistEntrega: number[],
        clienteCadastrado?: boolean,
        descCliente?: string,
        tipoVistoriaCliente?: boolean,
        tipoVistoriaConstrutora?: boolean,
        localVistoria?: string,
        status?: number
    ): Promise<number> {
        const result = await this.service.createEntregaObrasCliente({
            idEntregaObra,
            idClienteUnidade,
            idCentroCusto,
            idsChecklistEntrega,
            clienteCadastrado,
            descCliente,
            tipoVistoriaCliente,
            tipoVistoriaConstrutora,
            localVistoria,
            status,
        });
        return result.idEntregaObraCliente;
    }

    async updateEntregaObrasClienteChecklistById(
        idEntregaObraCliente: number,
        localVistoria?: string,
        idFuncionarioInsp?: number,
        idFuncionarioReinsp?: number,
        dataInspecao?: Date,
        dataReinsp?: Date,
        status?: number,
        analiseVistoria?: string,
        itensChecklist?: VerificacaoChecklistModel[],
    ): Promise<void> {
        await this.service.updateEntregaObrasClienteChecklistById({
            idEntregaObraCliente,
            localVistoria,
            idFuncionarioInsp,
            idFuncionarioReinsp,
            dataInspecao,
            dataReinsp,
            status: status ?? 0,
            analiseVistoria,
            itensChecklist: itensChecklist ?? [],
        });
    }

    async getAllVerificacaoChecklist(
        idEntregaObraCliente: number
    ): Promise<Paginated<VerificacaoChecklistModel>> {
        const result = await this.service.getAllVerificacaoChecklistLista({ idEntregaObraCliente });
        return { ...result };

    }

    //#endregion

    //#region EntregaObrasArquivos

    async getAllEntregaObrasClienteArquivos(
        idEntregaObra: number
    ): Promise<Paginated<EntregaObraClienteArquivoModel>> {
        const result = await this.service.getAllEntregaObrasClienteArquivos({ idEntregaObra });
        return { ...result };
    }

    async getEntregaObrasClienteArquivo(
        idEntregaObraClienteArquivo: number
    ): Promise<EntregaObraClienteArquivoModel> {
        const result = await this.service.getEntregaObrasClienteArquivos({ idEntregaObraClienteArquivo });
        return { ...result };
    }

    async createEntregaObrasClienteArquivos(
        idEntregaObra: number,
        nome?: string,
        descricao?: string,
        arquivo?: File
    ): Promise<number> {
        const result = await this.service.createEntregaObrasClienteArquivos({
            idEntregaObra,
            nome,
            descricao,
            arquivo,
        });
        return result.idEntregaObraClienteArquivo;
    }

    async updateEntregaObrasClienteArquivos(
        idEntregaObraClienteArquivo: number,
        idEntregaObra: number,
        nome?: string,
        descricao?: string,
        arquivo?: File,
        limparArquivo?: boolean
    ): Promise<void> {
        await this.service.updateEntregaObrasClienteArquivos({
            idEntregaObraClienteArquivo,
            idEntregaObra,
            nome,
            descricao,
            arquivo,
            limparArquivo,
        });
    }

    async deleteEntregaObrasClienteArquivos(idEntregaObraClienteArquivo: number): Promise<void> {
        await this.service.deleteEntregaObrasClienteArquivos(idEntregaObraClienteArquivo);
    }

    async downloadEntregaObraClienteArquivoById(
        idEntregaObraClienteArquivo: number,
    ): Promise<Blob> {
        const result = await this.service.downloadEntregaObraClienteArquivoById({
            idEntregaObraClienteArquivo,
        });
        return result;
    }

    //#endregion


    //#region EntregaObrasClienteArquivosAux
    async getAllEntregaObrasClienteArquivosAux(
        idEntregaObraCliente: number,

    ): Promise<Paginated<EntregaObraClienteArquivoAuxModel>> {
        const result = await this.service.getAllEntregaObrasClienteArquivosAux({
            idEntregaObraCliente,
        });

        return { ...result };
    }

    async getEntregaObrasClienteArquivosAux(
        idEntregaObraClienteArquivoAux: number
    ): Promise<EntregaObraClienteArquivoAuxModel> {
        const result = await this.service.getEntregaObrasClienteArquivosAux({
            idEntregaObraClienteArquivoAux,
        });
        return { ...result };
    }

    async createEntregaObrasClienteArquivosAux(
        idEntregaObraCliente: number,
        nome?: string,
        descricao?: string,
        arquivo?: File
    ): Promise<number> {
        const result = await this.service.createEntregaObrasClienteArquivosAux({
            idEntregaObraCliente,
            nome,
            descricao,
            arquivo,
        });
        return result.idEntregaObraClienteArquivoAux;
    }

    async updateEntregaObrasClienteArquivosAux(
        idEntregaObraClienteArquivoAux: number,
        idEntregaObraCliente: number,
        nome?: string,
        descricao?: string,
        arquivo?: File,
        limparArquivo?: boolean
    ): Promise<void> {
        await this.service.updateEntregaObrasClienteArquivosAux({
            idEntregaObraClienteArquivoAux,
            idEntregaObraCliente,
            descricao,
            nome,
            arquivo,
            limparArquivo,
        });
    }

    async deleteEntregaObrasClienteArquivosAux(idEntregaObraClienteArquivoAux: number): Promise<void> {
        await this.service.deleteEntregaObrasClienteArquivosAux(idEntregaObraClienteArquivoAux);
    }


    async downloadEntregaObraClienteArquivoAuxById(
        idEntregaObraClienteArquivoAux: number
    ): Promise<Blob> {
        const result = await this.service.downloadEntregaObrasClienteArquivosAuxById({
            idEntregaObraClienteArquivoAux,
        });
        return result;
    }

    //#endregion

    //#region EntregaObrasClienteTermos

    async getAllEntregaObrasClienteTermos(
        idEntregaObraCliente: number,
    ): Promise<Paginated<EntregaObraClienteTermoModel>> {
        const result = await this.service.getAllEntregaObrasClienteTermos({
            idEntregaObraCliente,
        });
        return { ...result };
    }

    async createEntregaObrasClienteTermo(
        idEntregaObraCliente: number,
        idTermo: number[]
    ): Promise<void> {
        await this.service.createEntregaObrasClienteTermo({
            idEntregaObraCliente,
            idTermo,
        });
    }

    async deleteEntregaObrasClienteTermo(idEntregaObraClienteTermo: number): Promise<void> {
        await this.service.deleteEntregaObrasClienteTermo(idEntregaObraClienteTermo);
    }



    //#endregion

    //#region InformacoesEntregaObrasCliente

    async getAllInformacoesEntregaObrasCliente(
        idEntregaObraCliente: number,
    ): Promise<Paginated<InformacoesEntregaObraClienteModel>> {
        const result = await this.service.getAllInformacoesEntregaObrasCliente({
            idEntregaObraCliente,
        });
        return { ...result };
    }

    async getInformacoesEntregaObrasCliente(
        idInformacoesEntregaObraCliente: number
    ): Promise<InformacoesEntregaObraClienteModel> {
        const result = await this.service.getInformacoesEntregaObrasCliente({
            idInformacoesEntregaObraCliente,
        });
        return { ...result };
    }

    async createInformacoesEntregaObrasCliente(
        idEntregaObraCliente?: number,
        idVerificacaoChecklist?: number,
        dataDescricao?: Date,
        dataTratativa?: Date,
        descricao?: string,
        tratativa?: string,
        inspecao?: number,

        descricaoArquivo?: string,
        arquivo?: File,
        nomeArquivo?: string,

        descricaoArquivo2?: string,
        arquivo2?: File,
        nomeArquivo2?: string
    ): Promise<void> {
        await this.service.createInformacoesEntregaObrasCliente({
            idEntregaObraCliente,
            idVerificacaoChecklist,
            dataDescricao,
            dataTratativa,
            descricao,
            tratativa,
            inspecao,

            descricaoArquivo,
            arquivo,
            nomeArquivo,
            descricaoArquivo2,
            arquivo2,
            nomeArquivo2,
        });
    }

    async updateInformacoesEntregaObrasCliente(
        idInformacoesEntregaObraCliente: number,
        idEntregaObraCliente?: number,
        idVerificacaoChecklist?: number,
        dataDescricao?: Date,
        dataTratativa?: Date,
        descricao?: string,
        tratativa?: string,
        inspecao?: number,

        descricaoArquivo?: string,
        nomeArquivo?: string,
        arquivo?: File,
        limparArquivo?: boolean,

        descricaoArquivo2?: string,
        nomeArquivo2?: string,
        arquivo2?: File,
        limparArquivo2?: boolean

    ): Promise<void> {
        await this.service.updateInformacoesEntregaObrasCliente({
            idInformacoesEntregaObraCliente,
            idEntregaObraCliente,
            idVerificacaoChecklist,
            dataDescricao,
            dataTratativa,
            descricao,
            tratativa,
            inspecao,

            descricaoArquivo,
            nomeArquivo,
            arquivo,
            limparArquivo,

            descricaoArquivo2,
            nomeArquivo2,
            arquivo2,
            limparArquivo2

        });
    }

    async deleteInformacoesEntregaObrasCliente(idInformacoesEntregaObraCliente: number): Promise<void> {
        await this.service.deleteInformacoesEntregaObrasCliente(idInformacoesEntregaObraCliente);
    }

    async downloadInfoEntregaObraClienteArquivoById(
        idInformacoesEntregaObraCliente: number,
        nroArquivo: number,
    ): Promise<Blob> {
        const result = await this.service.downloadInfoEntregaObrasClienteArquivosById(
            idInformacoesEntregaObraCliente,
            nroArquivo,
        );
        return result;
    }

    //#endregion


    //#region EntregaObrasClientePesquisaSatisfacao

    async getAllEntregaPesquisaSatisfacao(
        idEntregaObraCliente: number,
    ): Promise<Paginated<EntregaObraPesquisaSatisfacaoLista>> {
        const result = await this.service.getAllEntregaObrasClientePesquisaSatisfacao({
            idEntregaObraCliente,
        });
        return { ...result };
    }

    async getEntregaPesquisaSatisfacaoById(
        idEntregaPesquisa: number
    ): Promise<EntregaObraPesquisaSatisfacao> {
        const result = await this.service.getEntregaObrasClientePesquisaSatisfacaoById({
            idEntregaPesquisa,
        });
        return { ...result };
    }

    async createEntregaPesquisaSatisfacao(
        idEntregaObraCliente?: number,
        idPesquisaSatisfacao?: number,
    ): Promise<void> {
        await this.service.createEntregaObrasClientePesquisaSatisfacao({
            idEntregaObraCliente,
            idPesquisaSatisfacao,
        });
    }

    async updateEntregaPesquisaSatisfacao(
        idEntregaPesquisa: number,
        status: number,
        idEntregaObraCliente?: number,
        data?: Date,
        observacao?: string,
        itens?: ItemPesquisaEntregaObra[],

    ): Promise<void> {
        await this.service.updateEntregaObrasClientePesquisaSatisfacao({
            idEntregaPesquisa,
            status,
            idEntregaObraCliente,
            data,
            observacao,
            itens,
        });
    }

    async deleteEntregaPesquisaSatisfacao(idEntregaPesquisa: number): Promise<void> {
        await this.service.deleteEntregaObrasClientePesquisaSatisfacao(idEntregaPesquisa);
    }

    //#endregion

    async getDashboardEntregaObrasInformation(
    ): Promise<DashboardEntregaObras> {
        const result = await this.service.getDashboardEntregaObrasInformation({});
        return result.item;
    }
}
